module.exports = __webpack_public_path__ + "static/DHCM2-08f13a96fcbeb1e11a0871f26e6a8fbf.png";